import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index_custom.css";
import reportWebVitals from "./reportWebVitals";
import { store } from "./state/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (typeof window !== "undefined") {
  const resizeObserverErr =
    "ResizeObserver loop completed with undelivered notifications.";
  window.addEventListener("error", (e) => {
    if (e.message === resizeObserverErr) {
      e.stopImmediatePropagation();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.message === resizeObserverErr) {
      e.preventDefault();
    }
  });
}
window.addEventListener("error", (e) => {
  if (e.message?.includes("Typesetting failed")) {
    e.preventDefault();
    console.warn("MathJax skipped because element not mounted");
  }
});

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
